import { render } from "./PendingAcceptanceCard.vue?vue&type=template&id=fa520d7a"
import script from "./PendingAcceptanceCard.vue?vue&type=script&lang=js"
export * from "./PendingAcceptanceCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__